import { render, staticRenderFns } from "./TwismWalletSendCoins.vue?vue&type=template&id=a7acab1e&scoped=true&"
import script from "./TwismWalletSendCoins.vue?vue&type=script&lang=ts&"
export * from "./TwismWalletSendCoins.vue?vue&type=script&lang=ts&"
import style0 from "./TwismWalletSendCoins.vue?vue&type=style&index=0&id=a7acab1e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7acab1e",
  null
  
)

export default component.exports